module.exports = __webpack_public_path__ + "static/media/location.8d74fcb7.svg";